// extracted by mini-css-extract-plugin
export var root = "section-library-hero-module--root--064N5";